import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import PrevButton from './PrevButton';
import ProgressBar from './ProgressBar';

interface IHeader {
  title: string;
}

const Header: React.FC<IHeader> = ({ title }) => {
  return (
    <Container className="pt-4">
      <Row>
        <Col xs={12} md={{ size: 8, offset: 2 }} xl={{ size: 4, offset: 4 }}>
          <Row className="d-none d-md-block">
            <Col xs={{ size: 6, offset: 3 }}>
              <p className="text-center small text-text-variant-color mb-s">{title}</p>
              <ProgressBar />
            </Col>
          </Row>
          <Row className="d-md-none align-items-center">
            <Col xs={{ size: 3 }} className="d-md-none">
              <PrevButton asArrow />
            </Col>
            <Col xs={{ size: 6 }}>
              <p className="text-center small text-text-variant-color mb-s">{title}</p>
              <ProgressBar />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Header;
